export const CALENDER = 'CALENDER'
export const INFOR = 'INFO'
export const RATING = 'RATING'

export const TRAILER = 'TRAILER'
export const USER_LOG_IN = 'userLogin'
export const SUCCESS = 200
export const FORBIDDEN = 403

export const VIP = 'VIP'

export const FILM_INFOR = 'filmInfor'


export const EDIT_USER_TEMP = 'EDIT_USER_TEMP'

export const ADMIN = 'QuanTri'
export const CUSTOMER = 'KhachHang'